import React from 'react';
import { Box } from '@chakra-ui/react';

import { ItemsSummaryAccordion } from '../../../../../../../common/components/ItemsSummaryModal/ItemsSummaryAccordion';
import { DepositRelevoTableMode } from '../../../../../model/enums/deposit-relevo-table-mode.enum';
import { useDepositSuccessResult } from '../../../../hooks/use-deposit-success-result.hook';
import { DepositRelevoTable } from '../../../DepositRelevoTable/DepositRelevoTable';

export const ItemsTable = () => {
  const { successText, isAnyItemExpired, mode, mappedItems } = useDepositSuccessResult();

  return (
    <Box pt={2}>
      <ItemsSummaryAccordion buttonText={successText} isOpen={isAnyItemExpired}>
        <DepositRelevoTable tableMode={DepositRelevoTableMode.SUCCESS} scannerMode={mode} items={mappedItems} />
      </ItemsSummaryAccordion>
    </Box>
  );
};
